import { ref } from 'vue'
import {speaker} from '@stream'

// Shared across callers: the speaker itself is a singleton
const isMuted = ref(speaker.muted)

export default function useSpeaker () {
  const isPlaying = ref(false)
  const play = async (sound) => {
    isPlaying.value = true
    await speaker.play(sound)
    isPlaying.value = false
  }

  const change = async (deviceId, deviceLabel) => {
    await speaker.change(deviceId, deviceLabel)
  }

  const toggleMute = () => {
    isMuted.value = !isMuted.value
    speaker.setMuted(isMuted.value)
  }

  return {
    sinkId: speaker.sinkId,
    isSupported: speaker.isSinkIdSupported,
    change,
    play,
    isPlaying,
    isMuted,
    toggleMute
  }
}
